import { connect } from 'react-redux';

import OrgForm from './OrgForm';
import { selectors } from '../../../../dux/user';

const mapStateToProps = (state) => ({
  initialValues: {
    primaryEmail: selectors.getIdentityState(state).email,
  },
});

export default connect(mapStateToProps, null)(OrgForm);
